import type { JSONSchema7 } from 'json-schema';

export type InvoiceSectionPickerUiOptions = {
  billingProfileId?: string;
  billingProfileField?: string;
  billingProfileIdMap?: Record<string, string>;
};

export type InvoiceSection = {
  id: string;
  displayName: string;
  status: 'Active' | 'Inactive' | 'Deleted';
  billingProfileId: string;
};

export const InvoiceSectionPickerSchema = {
  uiOptions: {
    type: 'object',
    anyOf: [
      { required: ['billingProfileId'] },
      { required: ['billingProfileField'] },
    ],
    properties: {
      billingProfileId: {
        type: 'string',
        title: 'Billing Profile ID',
        description:
          'The ID of the billing profile to fetch invoice sections from',
      },
      billingProfileField: {
        type: 'string',
        title: 'Billing Profile Form Field',
        description:
          'Name of the form field containing the selected billing profile',
      },
      billingProfileIdMap: {
        type: 'object',
        title: 'Billing Profile ID Map',
        additionalProperties: { type: 'string' },
      },
    },
  } as JSONSchema7,
  returnValue: {
    title: 'Selected Invoice Section ID',
    type: 'string',
  } as JSONSchema7,
};
